// extracted by mini-css-extract-plugin
module.exports = {"form":"FormPreview_form__2eOfa","placeholder":"FormPreview_placeholder___lG11"};